export enum StationActionType {
  CREATE = 'CREATE',
  UNINSTALL = 'UNINSTALL',
  DELETE = 'DELETE',
  REINSTALL = 'REINSTALL',
  EDIT = 'EDIT'
}
